import { render, staticRenderFns } from "./reportedDialog.vue?vue&type=template&id=2ee03bfa&scoped=true"
import script from "./reportedDialog.vue?vue&type=script&lang=ts"
export * from "./reportedDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee03bfa",
  null
  
)

export default component.exports